import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "environments/environment";
import { User } from "app/auth/models";
import { Router } from "@angular/router";
import { log } from "console";
import Swal from "sweetalert2";

@Injectable({ providedIn: "root" })
export class CommunicationService {
  /**
   *
   * @param {HttpClient} _http
   * @param {Router} _router

   */
  constructor(private _router: Router, private _http: HttpClient) {}

  /**
   * Get customer by id
   */
  sendEmail(data) {
    return new Promise((resolve, reject) => {
      this._http
        .post(`${environment.apiUrl}/send/email`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  /**
   * Get customer by id
   */
  sendSelfInvite(data) {
    return new Promise((resolve, reject) => {
      this._http
        .post(`${environment.apiUrl}/campaign/${data.token}/onboarding`, data.info)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  /**
   * Get customer by id
   */
  sendEmail2pay(order) {
    return new Promise((resolve, reject) => {
      this._http
        .post(`${environment.apiUrl}/onboarding`,
          order)
        .subscribe((response: any) => {
          resolve(response);
        }, (error) => {
          console.error(error);
          reject(error);
        });
    });
  }
  /**
   * Check new members eligibility
   */
  checkAccountHolder(info: string) {
    return new Promise((resolve, reject) => {
      this._http
        .get(`${environment.apiUrl}/member`)
        .subscribe((response: any) => {
          const members = response;
          const member = members.find((m) => m.email === info);

          if (member && member.status === "active") {
            resolve(true);
          } else {
            resolve(false);
          }
        }, reject);
    });
    // return new Promise((resolve, reject) => {
    //   this._http.post(`${environment.apiUrl}/members/check/${type}`, {"check_info": info}).subscribe((response: any) => {
    //     resolve(response);
    //   }, reject);
    // });
  }

  /**
   * Check new members eligibility
   */
  checkNewMembers(token: string, data: any, plans: any, radioModel) {
    // return new Promise((resolve, reject) => {
    //   this._http
    //     .post(`${environment.apiUrl}/onboarding/${token}/checkEligibility`, {
    //       list: data,
    //       plan: plans,
    //       paymentModal: radioModel,
    //     })
    //     .subscribe((response: any) => {
    //       resolve(response);
    //     }, reject);
    // });
  }

  getReferralByToken(token: string) {
    return this._http.get(`${environment.apiUrl}/onboarding/${token}`);
  }

  sendOrder(onboarding_id) {
    return new Promise((resolve, reject) => {
      this._http
        .patch(`${environment.apiUrl}/onboarding/${onboarding_id}/submit`, null)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  checkCoupon(code, onboarding_id){
    return this._http
        .get(`${environment.apiUrl}/coupon/${code}/onboarding/${onboarding_id}`);
  }

  checkMemberCoupon(code){
    return this._http
        .get(`${environment.apiUrl}/coupon/${code}/member`);
  }

  updateOrder(onboarding_id, order: any) {
    return new Promise((resolve, reject) => {
      this._http
        .patch(`${environment.apiUrl}/onboarding/${onboarding_id}/update`, order)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }


  usePaymentMethod(token: any, type: string) {
    return new Promise((resolve, reject) => {
      this._http
        .patch(`${environment.apiUrl}/onboarding/${token}/approve`, {"type": type})
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  requestNewCustomer(info: any) {
    return new Promise((resolve, reject) => {
      this._http
        .post(`${environment.apiUrl}/new_customers`, info)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  getSelfInviteInfo(token) {
    if(token.length == 36){
      return this._http.get(`${environment.apiUrl}/campaign/${token}/onboarding`);
    }else{
      return this._http.get(`${environment.apiUrl}/campaign/${token}/referral`);
    }
  }

  getPaymentByToken(token, returnLink) {
    return this._http.patch(`${environment.apiUrl}/instalment_payment/${token}/get_info`, {"returnLink":returnLink});
  }

  getOverdueByToken(token) {
    return this._http.get(`${environment.apiUrl}/invoice/${token}/get_info`);
  }

  confirmOverduePayment(token: any, type: string) {
    return new Promise((resolve, reject) => {
      this._http
        .patch(
          `${environment.apiUrl}/invoice/${token}/approve`,
          {
            "token": token,
            "type": type,
          }
        )
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }


  confirmPayment(order: any, type: string) {
    return new Promise((resolve, reject) => {
      this._http
        .patch(
          `${environment.apiUrl}/instalment_payment/${order.token}/approve`,
          {
            order: order,
            type: type,
          }
        )
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }
}
